import React from "react";
import "./App.css";
import { AiFillMail } from "react-icons/ai";
import { AiOutlineCopyright } from "react-icons/ai";

function App() {
  return (
    <div className="App">
      <div className="header-container">
        <a
          href="https://apps.apple.com/au/app/fantasy-market/id6503198536?itscg=30200&amp;itsct=apps_box_appicon"
          className={"header-logo"}
        >
          <img
            src="https://is1-ssl.mzstatic.com/image/thumb/Purple221/v4/b7/c0/42/b7c042b0-8514-91d7-d75f-486175485e97/AppIcon-0-0-1x_U007emarketing-0-5-0-85-220.png/540x540bb.jpg"
            alt="Fantasy Market"
            className={"header-logo-image"}
          />
        </a>
        <h1 className="header-title">Fantasy Market</h1>
      </div>
      <div className="about">
        <h1>About</h1>
        <div>
          <h2>Fantasy Market: Compete, Trade, Conquer!</h2>
        </div>
        <p />
        <div>
          Welcome to Fantasy Market, the ultimate stock trading game that lets
          you dive into the world of finance with virtual capital! Compete with
          friends, test your trading skills, and become the top trader in this
          thrilling, real-data-driven simulation.
        </div>
        <p />
        <div>
          <div>Key Features:</div>
          <p />
          <div>
            {" "}
            📈 Real-Time Trading: Buy and sell stocks with values reflecting the
            real market, and watch your portfolio grow.
          </div>
          <p />
          <div>
            🏆 Compete with Friends: Add friends and rivals, climb the
            leaderboard, and see who’s the best trader.
          </div>
          <p />
          <div>🎮 And more: More function coming soon...</div>
        </div>
        <p />
        <div>
          Join thousands of traders and start your journey to financial
          supremacy! Whether you’re a seasoned trader or a beginner, Fantasy
          Market is your gateway to mastering the stock market. Download Fantasy
          Market now and start trading your way to the top!
        </div>
      </div>
      <div className="appStores">
        <h1>App Stores</h1>
        <div>
          Download the app today and start your journey into stock markets!
        </div>
        <div className="links">
          <a
            href="https://apps.apple.com/au/app/fantasy-market/id6503198536?itsct=apps_box_badge&amp;itscg=30200"
            className={"appleEmbed"}
          >
            <img
              src="https://tools.applemediaservices.com/api/badges/download-on-the-app-store/black/en-us?size=250x83&amp;releaseDate=1718409600"
              alt="Download on the App Store"
              className="appleImage"
            />
          </a>
          <a
            className="playstore"
            href="https://play.google.com/store/apps/details?id=com.fantasymarket"
          >
            <img
              src="https://play.google.com/intl/en_us/badges/images/generic/en_badge_web_generic.png"
              alt=""
            />
          </a>
        </div>
        <div className="store-images">
          <img src={require("./assets/Hotpot 0.png")} alt="" />
          <img src={require("./assets/Hotpot 1.png")} alt="" />
          <img src={require("./assets/Hotpot 2.png")} alt="" />
          <img src={require("./assets/Hotpot 3.png")} alt="" />
          <img src={require("./assets/Hotpot 4.png")} alt="" />
        </div>
      </div>
      <div className="about">
        <h1>How to delete your account?</h1>
        <ul>
          <li>Login into the app.</li>
          <li>Press on settings button.</li>
          <li>Press on Delete Account button.</li>
        </ul>
      </div>
      <div className="footer">
        <h3>Fantasy Market</h3>
        <div className="hash">#stocks #market #simulation</div>
        <div className="support">
          <a href="mailto:denyslindidev@gmail.com?subject=Fantasy Market Support">
            <AiFillMail size={32} fill={"white"} />
          </a>
        </div>
        <div className="copyright">
          <AiOutlineCopyright size={16} fill={"white"} />
          <div className="name">DenysL Indi Dev</div>
        </div>
      </div>
    </div>
  );
}

export default App;
